import update from 'immutability-helper';
import { ActionType, defaultAction } from 'src/redux/types';
import { CreatedVaResponseData, StatusData, VaData } from '../types';
import { ACTION_TYPES } from './types';

export type CreatedVaState = {
  data: CreatedVaResponseData;
  isLoading: boolean;
  error: StatusData | Record<string, unknown>;
};

export type CreatedVaDetailState = {
  data: VaData;
  isLoading: boolean;
  error: boolean;
};

export type VirtualAccountState = {
  createdVa: CreatedVaState;
  createdVaDetail: CreatedVaDetailState;
};

const initialState: VirtualAccountState = {
  createdVa: {
    data: {
      data: [],
      status: {},
      total: 0,
    },
    isLoading: false,
    error: {},
  },
  createdVaDetail: {
    isLoading: true,
    data: {
      amount: 0,
      amount_detected: 0,
      bank_code: '',
      bank_name: '',
      counter_incoming_payment: 0,
      created: 0,
      expiration_time: 0,
      id: '',
      is_open: false,
      is_single_use: false,
      partner_user_id: '',
      status: {},
      trx_counter: 0,
      trx_expiration_time: 0,
      username_display: '',
      va_number: '',
      va_status: '',
      list: [],
    },
    error: false,
  },
};

export default (state = initialState, action: ActionType = defaultAction) => {
  const { payload, type } = action;
  switch (type) {
    case ACTION_TYPES.CREATED_VA_LIST:
      return update(state, {
        createdVa: {
          isLoading: {
            $set: true,
          },
        },
      });
    case ACTION_TYPES.CREATED_VA_LIST_SUCCESS:
      return update(state, {
        createdVa: {
          $merge: {
            data: payload,
            isLoading: false,
          },
        },
      });
    case ACTION_TYPES.CREATED_VA_LIST_FAILED:
      return update(state, {
        createdVa: {
          $merge: {
            error: payload.response.data.error,
            isLoading: false,
          },
        },
      });
    case ACTION_TYPES.CREATED_VA_DETAIL:
      return update(state, {
        createdVaDetail: {
          isLoading: {
            $set: true,
          },
        },
      });
    case ACTION_TYPES.CREATED_VA_DETAIL_SUCCESS:
      return update(state, {
        createdVaDetail: {
          $merge: {
            data: payload,
            isLoading: false,
            error: !(payload.status.code === '000'),
          },
        },
      });
    case ACTION_TYPES.CREATED_VA_DETAIL_FAILED:
      return update(state, {
        createdVaDetail: {
          $merge: {
            error: true,
            isLoading: false,
          },
        },
      });
    default:
      return state;
  }
};
